// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GGmn","rightAdornment":"Header_rightAdornment__3wy7v"};